// HeartPopup.jsx
import React, { useState, useRef, useEffect } from "react";
import "./HeartPopup.css";
import heart from '../imagesHome/heart.png';

const HeartPopup = ({ livesCount }) => {
  const [open, setOpen] = useState(false);
  const [closing, setClosing] = useState(false);
  const popupRef = useRef(null);
  const [animateLoss, setAnimateLoss] = useState(false);
  const previousLivesCount = useRef(livesCount);



  const closePopup = () => {
    if (closing || (!open && !closing)) return;
    setOpen(false);
    setClosing(true);
    setTimeout(() => {
      setClosing(false);
    }, 300);
  };



  useEffect(() => {
  if (livesCount < previousLivesCount.current) {
    // utilizatorul a pierdut o viață
    setAnimateLoss(true);

    setTimeout(() => setAnimateLoss(false), 500);
  }

  previousLivesCount.current = livesCount;
}, [livesCount]);

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, closing]);

  useEffect(() => {
    if (open || closing) {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    } else {
      document.body.classList.add("quiz-active");
      document.documentElement.classList.add("quiz-active");
    }

    return () => {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    };
  }, [open, closing]);

  return (
    <div className="heart-popup-container">
      <div
        className="oiented-heart-track"
        onClick={() => {
          if (closing) return;
          setClosing(false);
          setOpen(true);
        }}
      >
        <img 
  src={heart} 
  className={`heart-popup-icon ${animateLoss ? "heart-lost heart-shake" : ""}`}
  draggable={false}
/>

<div className={`value-hearts ${animateLoss ? "heart-lost" : ""}`}>
  {livesCount}
</div>

      </div>

      {(open || closing) && (
        <>
          <div className="heart-popup-overlay" onClick={closePopup} />
          <div
            className={`heart-popup ${open ? "open" : ""} ${closing ? "closing" : ""}`}
            ref={popupRef}
          >
            <button className="heart-popup-close" onClick={closePopup}>
              ×
            </button>
            <div className="heart-popup-content">
              <div className="heart-popup-number">{livesCount}</div>
              <img src={heart} className="heart-popup-bigicon" draggable={false} />
              <h3>Ai {livesCount} vieți</h3>
              <p>Folosește-le pentru a relua lecții sau a continua după greșeli.</p>
              <button className="heart-popup-btn">Cumpără vieți</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default HeartPopup;
